<template>
  <div class="right-menu__feedback">
    <div class="right-menu__title">
      <h4>Написать директору</h4>
    </div>
    <div class="t-form marginBottom">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.name }">
          <input
            type="text"
            id="feedback-owner-name"
            v-model="data.name"
            @click="() => clearError('name')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.name }"
            for="feedback-name"
          >
            ФИО
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.nameText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.phone }">
          <input
            type="text"
            id="feedback-owner-phone"
            @input="phoneFormat"
            :value="data.phone"
            maxlength="17"
            @click="() => clearError('phone')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.phone }"
            for="feedback-phone"
          >
            Номер телефона
          </label>
          <span class="t-form__input-error">{{ errors.phoneText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.email }">
          <input
            type="email"
            id="feedback-owner-email"
            v-model="data.email"
            @click="() => clearError('email')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.email }"
            for="feedback-email"
          >
            E-mail
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.emailText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.message }">
          <textarea
            id="feedback-owner-message"
            rows="5"
            v-model="data.message"
            @click="() => clearError('message')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.message }"
            for="feedback-message"
          >
            Комментарий
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.messageText }}</span>
        </div>
      </div>
    </div>
    <p class="right-menu__text">
      Нажимая кнопку зарегистрироваться вы даете согласие на обработку
      персональных данных
    </p>
    <t-button type="small blue uppercase" :callback="submit"
      >Отправить</t-button
    >
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { mapMutations, mapState, mapActions } from 'vuex';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';

export default {
  components: {
    't-button': Button,
  },
  data: function() {
    return {
      data: {
        name: '',
        phone: '',
        email: '',
        message: '',
      },
      errors: {
        name: false,
        nameText: '',
        phone: false,
        phoneText: '',
        message: false,
        messageText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('api', ['feedbackOwner']),
  },
  methods: {
    ...mapMutations('params', ['toogleFeedackOwner', 'toogleConfirmBlock']),
    ...mapActions('api', ['fetchRequest']),

    phoneFormat: function({ target }) {
      this.data.phone = setPhoneFormat(target.value);
    },

    validation: function() {
      let error = false;

      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim() && item !== 'phone') {
          this.setErrors(item, 'empty');
          error = true;
        }
      });

      return error;
    },
    setErrors: function(id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },

    clearError: function(id) {
      this.errors[id] = false;
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    submit: function() {
      if (this.validation()) return;

      this.fetchRequest({
        url: this.feedbackOwner,
        form: this.form({ ...this.data }),
        success: (data) => {
          console.log('success', data);
          if (data.body.success) {
            this.toogleFeedackOwner();
            this.toogleConfirmBlock({ title: 'Ваше сообщение отправлено' });
          }
        },
        error: (e) => {
          console.log('error', e);
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.marginBottom
  margin-bottom: 32px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/feedbackOwner.vue